import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loginUser } from "../../services/authService"; 
import "./login.css";
import mylogo from "../../myimgs/nivora 1.png";
import email from "../../myimgs/email.png";
import pwd from "../../myimgs/pwd.png";
import Header from "../../components/Navbar";
import Swal from "sweetalert2";
import Lofinimg from "../../myimgs/mobile style.png";
import play from "../../myimgs/Play app 1.png";
import app from "../../myimgs/Play app 2.png";

const Login = () => {
  const navigate = useNavigate();

  // ✅ Form state
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ✅ Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await loginUser(formData);

      console.log("Login Response:", res.data);

      const token = res.data?.data?.token;
      const name = res.data?.data?.name;
      const userId = res.data?.data?.userId;

      if (!token) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Token not found in response!",
        });
        return;
      }

      // ✅ Save token to localStorage
      localStorage.setItem("token", token);
      localStorage.setItem("userName", name);
      localStorage.setItem("userId", userId);

      Swal.fire({
        icon: "success",
        title: "Login Successful!",
        text: "Welcome back to Twoffers!",
        timer: 1500,
        showConfirmButton: false,
      });

      navigate("/");
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: err.response?.data?.message || "Invalid email or password!",
      });
    } finally {
      setLoading(false);
    }
  };

  // ✅ Google Login Redirect Handler
  const handleGoogleLogin = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    window.location.href = `${baseURL}/auth/google`;
  };

  return (
    <>
      <Header />
      <div className="login-container scrolleffect lognji">
        {/* Left Side Image Section */}
        <div className="login-left">
          <img src={Lofinimg} alt="" />
          <div className="overlay-text">
            <h2>Get Twoffers App</h2>
            <p>
             Your next deal is always in reach. With the Twoffers app, you can browse, offer, and close on the go.
            </p>
          </div>
            <div className="flxname lofixname">
            <Link to="https://play.google.com/store/apps/details?id=com.twoffers">
              <img src={play} alt="" />
            </Link>
            <Link to="https://apps.apple.com/ae/app/twoffers/id6751880823">
              <img src={app} alt="" />
            </Link>
          </div>
        </div>

        {/* Right Side Form Section */}
        <div className="login-right">
          <div className="login-box">
            {/* Logo */}
            <div className="logo mb-3">
              <Link to="/">
                <img src={mylogo} alt="Logo" style={{ height: "50px" }} />
              </Link>
            </div>

            <h5 className="fw-bold">Welcome to Twoffers!</h5>
            <p className="text-muted small">
              Sign in to view your notifications, offers, saved searches.
              <br />
              New here?{" "}
              <Link to="/signup" className="link-primary">
                Create your free account.
              </Link>
            </p>

            {/* ✅ Login Form */}
            <form onSubmit={handleSubmit}>
              {/* Email Input */}
              <div className="input-group mb-3">
                <span className="input-group-text">
                  <img src={email} alt="" />
                </span>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Email Address"
                  required
                />
              </div>

              {/* Password Input */}
              <div className="input-group mb-3">
                <span className="input-group-text">
                  <img src={pwd} alt="" />
                </span>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Password"
                  required
                />
              </div>

              {/* Sign In Button */}
              <button
                type="submit"
                className="btn btn-dark w-100 mb-3"
                disabled={loading}
              >
                {loading ? "Signing in..." : "SIGN IN"}
              </button>
            </form>

            <div className="text-center mb-3 orclass">Or</div>

            {/* ✅ Google Login Button */}
            <button
              onClick={handleGoogleLogin}
              className="btn btn-outline-dark w-100 mb-2"
            >
              Continue with Google
            </button>

            {/* Terms */}
            <p className="text-muted small text-center mt-3">
              Continue with Google means you agree to Twoffers{" "}
              <Link to="/termsandconditions" className="link-primary">
                Terms
              </Link>{" "}
              and{" "}
              <Link to="/privacypolicy" className="link-primary">
                Privacy Policy
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
